/* Unfreeze the page after the Klaviyo email popup closes.

   THE BUG, measured on the live page. Closing the popup left the page
   looking normal but completely dead: no scrolling, no clicks. THREE things
   cause it, and fixing any one alone leaves the page frozen -- which is why
   this took several attempts.

   (A) THE SCROLL LOCK
       Klaviyo puts  klaviyo-prevent-body-scrolling  on <body>, and their
       stylesheet gives it overflow:hidden. Their close never removes it.

   (B) THE STRANDED OVERLAY
       Their close only fades the OUTER FIXED WRAPPER to opacity 0. The
       element stays in the document, position:fixed, 528x773, z-index
       90000 -- an invisible sheet of glass over the page.

   (C) THEIR CHILDREN OPT BACK IN
       pointer-events:none on that wrapper is NOT enough. Klaviyo's own CSS
       sets pointer-events:auto on the elements inside it, which overrides
       inheritance, so the form markup inside the invisible wrapper went on
       swallowing clicks. Measured: wrapper computed none, children computed
       auto, and elementFromPoint at the centre of the screen still returned
       a Klaviyo div -- the page was frozen even after the scroll lock had
       been cleared.

   WHY AN EARLIER FIX DID NOT WORK. The old visibility test read an
   element's OWN computed opacity. getComputedStyle does NOT inherit a
   parent's opacity, so every field inside that faded wrapper still reported
   opacity 1 with real width and height. The guard concluded a form was open
   and refused to release anything. Visibility here therefore walks the
   ANCESTORS.

   HOW IT IS NEUTRALISED. Parked overlays get an attribute, and a stylesheet
   rule kills pointer events on the element AND EVERYTHING INSIDE IT with
   !important, which is what beats (C). Nothing is removed from the document
   and no inline styles are written onto Klaviyo's markup.

   AND HOW IT IS GIVEN BACK -- do not drop this. A parked overlay is also
   WATCHED. Klaviyo reopens a popup by restoring that same wrapper, so
   without a watcher nothing ever re-checks it and the popup can never open
   again: measured as reopened=false, the form present but un-clickable. The
   watcher fires on its style/class changing, the form becomes genuinely
   visible, and everything is handed straight back.

   This NEVER closes or hides a form.

   No regex literals: this file is written through an API that passes
   backslashes through verbatim. */
(function () {
  if (window.__irrPopup) return;
  window.__irrPopup = 1;

  var LOCKS = [
    'klaviyo-prevent-body-scrolling',
    'kl-prevent-body-scrolling',
    'kl-modal-open'
  ];

  var KL = '[class*="kl-private-reset"],[data-testid="MODAL"],.klaviyo-form';
  var FIELD = 'input,textarea,select,button,a[href]';
  var PARKED = 'data-irr-parked';
  var queued = false;

  /* (C). The descendant selector is the whole point -- without it Klaviyo's
     own pointer-events:auto on the inner markup wins. */
  (function sheet() {
    var s = document.createElement('style');
    s.setAttribute('data-irr-popup', '');
    s.textContent =
      '[' + PARKED + '],[' + PARKED + '] *{pointer-events:none !important}';
    (document.head || document.documentElement).appendChild(s);
  })();

  /* Visibility INCLUDING ancestors. */
  function visible(el) {
    if (!el || !el.isConnected) return false;

    if (typeof el.checkVisibility === 'function') {
      try {
        if (!el.checkVisibility({
          opacityProperty: true,
          visibilityProperty: true,
          contentVisibilityAuto: true
        })) return false;
      } catch (e) { /* older signature - fall through to the walk */ }
    }

    var n = el;
    while (n && n.nodeType === 1) {
      var c = getComputedStyle(n);
      if (c.display === 'none') return false;
      if (c.visibility === 'hidden' || c.visibility === 'collapse') return false;
      if (parseFloat(c.opacity) === 0) return false;
      n = n.parentElement;
    }

    var r = el.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }

  /* A container only counts as open if something inside it is genuinely
     usable. A stranded overlay has width and height too. */
  function liveForm() {
    var els = document.querySelectorAll(KL);
    for (var i = 0; i < els.length; i++) {
      if (!visible(els[i])) continue;
      var bits = els[i].querySelectorAll(FIELD);
      for (var j = 0; j < bits.length; j++) {
        if (visible(bits[j])) return true;
      }
    }
    return false;
  }

  /* Re-check whenever Klaviyo touches a parked overlay. This is what lets
     the popup open again; without it the park is permanent. The filter
     deliberately excludes our own attribute, so parking cannot retrigger
     this and loop. */
  function watch(el) {
    if (el.__irrWatched || !window.MutationObserver) return;
    el.__irrWatched = 1;
    new MutationObserver(schedule).observe(el, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  /* Park every Klaviyo overlay that is fixed, covers a meaningful slab of
     the screen, and is NOT visible. Attribute only -- the stylesheet above
     does the work, so Klaviyo's own markup is never written to. */
  function parkOverlays() {
    var els = document.querySelectorAll(KL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (getComputedStyle(el).position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (r.width < 120 || r.height < 120) continue;
      if (visible(el)) continue;
      if (!el.hasAttribute(PARKED)) el.setAttribute(PARKED, '1');
      watch(el);
    }
  }

  function unparkOverlays() {
    var els = document.querySelectorAll('[' + PARKED + ']');
    for (var i = 0; i < els.length; i++) els[i].removeAttribute(PARKED);
  }

  function release() {
    queued = false;

    /* The theme's own drawers and modals are <dialog>s and lock the page on
       purpose while they are open. Not ours to release. */
    if (document.querySelector('dialog[open]')) return;

    if (liveForm()) {
      /* A popup really is open. Hand back anything parked earlier so their
         overlay, fields and close button all work normally. */
      unparkOverlays();
      return;
    }

    parkOverlays();

    [document.documentElement, document.body].forEach(function (el) {
      if (!el) return;

      LOCKS.forEach(function (name) {
        if (el.classList.contains(name)) el.classList.remove(name);
      });

      var s = el.style;
      if (s.overflow === 'hidden') s.removeProperty('overflow');
      if (s.overflowY === 'hidden') s.removeProperty('overflow-y');
      if (s.position === 'fixed') {
        s.removeProperty('position');
        s.removeProperty('top');
        s.removeProperty('left');
        s.removeProperty('right');
        s.removeProperty('width');
      }
      if (s.touchAction === 'none') s.removeProperty('touch-action');
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    /* Two frames, then late passes: Klaviyo animates the form in and out
       after the click, so an immediate check can still see the old state.
       The 1200ms pass covers a slow fade on a busy page. */
    requestAnimationFrame(function () {
      requestAnimationFrame(release);
    });
    setTimeout(release, 500);
    setTimeout(release, 1200);
  }

  /* The close control is inside Klaviyo's markup, so the click is caught on
     the way up rather than bound to their button. */
  document.addEventListener('click', schedule, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') schedule();
  });

  if (window.MutationObserver) {
    /* Children of <body> being added or removed -- where overlays are
       injected -- plus the class and style attributes on <body>, which is
       what Klaviyo changes when it locks and unlocks scrolling. Not a
       whole-document observer. */
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  window.addEventListener('pageshow', schedule);
})();
